"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDC3ColumnFactoriesToVizPortalColumnFactories = void 0;
/**
 * For grids that are also used in VizPortal, we put the columns through this function to create
 * a wrapped version of the column factories that take in VizPortal's column params.
 */
function mapDC3ColumnFactoriesToVizPortalColumnFactories(dc3ColumnFactories, convertColumnParams) {
    return dc3ColumnFactories.map(function (dc3ColumnFactory) {
        return function (vizPortalColumnParams) {
            var dc3ColumnParams = convertColumnParams(vizPortalColumnParams);
            var column = dc3ColumnFactory(dc3ColumnParams);
            // When the column exists in VizPortal Client, change the data keys to lowercase so they will match the
            // lowercase sort fields that flow through VizPortal's system. This allows the data grid to match the column's
            // data key with the sort field name coming to the data grid props (via VPC's redux store) and give the correct
            // ARIA sorting indications on the column header.
            var dataKey = column.dataKey.toLowerCase();
            return __assign(__assign({}, column), { dataKey: dataKey });
        };
    });
}
exports.mapDC3ColumnFactoriesToVizPortalColumnFactories = mapDC3ColumnFactoriesToVizPortalColumnFactories;
//# sourceMappingURL=ColumnFactory.js.map